import { render, staticRenderFns } from "./app-service.vue?vue&type=template&id=5f643b3f&scoped=true&"
import script from "./app-service.vue?vue&type=script&lang=js&"
export * from "./app-service.vue?vue&type=script&lang=js&"
import style0 from "./app-service.vue?vue&type=style&index=0&id=5f643b3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f643b3f",
  null
  
)

export default component.exports